import { KeyValueStore, useMemoryData } from '../storage/index.js';
const loaderCache = useMemoryData('loader', () => new KeyValueStore());
const loaderError = useMemoryData('loader-error', () => new KeyValueStore());
export async function loadScript(scriptUrl, id, { disableCrossOrigin = false } = {}) {
    if (loaderCache().has(scriptUrl))
        return loaderCache().get(scriptUrl);
    const promise = new Promise((resolve, reject) => {
        const scriptEl = document.createElement('script');
        scriptEl.src = scriptUrl + cacheBuster(scriptUrl);
        scriptEl.async = true;
        scriptEl.dataset.name = id;
        scriptEl.onload = () => resolve();
        scriptEl.onerror = err => reject(new LoaderError(`Unable to load script: ${scriptUrl}`, err));
        if (!disableCrossOrigin) {
            scriptEl.crossOrigin = 'anonymous';
        }
        const el = document.getElementsByTagName('head')[0] || document.documentElement;
        el.appendChild(scriptEl);
    });
    const finalPromise = promise
        .then(() => {
        // remove previous error flag
        loaderError().remove(scriptUrl);
    })
        .catch(err => {
        // remove rejected promise from cache
        loaderCache().remove(scriptUrl);
        loaderError().set(scriptUrl, true);
        return Promise.reject(err);
    });
    loaderCache().set(scriptUrl, finalPromise);
    return finalPromise;
}
export async function loadStyle(styleUrl, id, { disableCrossOrigin = false } = {}) {
    if (isStyleExists(styleUrl))
        return Promise.resolve();
    if (loaderCache().has(styleUrl))
        return loaderCache().get(styleUrl);
    const promise = new Promise((resolve, reject) => {
        const linkEl = document.createElement('link');
        linkEl.href = styleUrl + cacheBuster(styleUrl);
        linkEl.rel = 'stylesheet';
        linkEl.dataset.name = id;
        linkEl.onload = () => resolve();
        linkEl.onerror = err => reject(new LoaderError(`Unable to load style: ${styleUrl}`, err));
        if (!disableCrossOrigin) {
            linkEl.crossOrigin = 'anonymous';
        }
        const el = document.getElementsByTagName('head')[0] || document.documentElement;
        el.appendChild(linkEl);
    });
    const finalPromise = promise
        .then(() => {
        // remove previous error flag
        loaderError().remove(styleUrl);
    })
        .catch(err => {
        // remove rejected promise from cache
        loaderCache().remove(styleUrl);
        loaderError().set(styleUrl, true);
        return Promise.reject(err);
    });
    loaderCache().set(styleUrl, finalPromise);
    return finalPromise;
}
export class LoaderError extends Error {
    constructor(message, cause) {
        super(message);
        this.cause = cause instanceof Error ? cause : new Error(cause);
    }
}
export function clearCache(url) {
    loaderCache().remove(url);
    loaderError().remove(url);
}
function cacheBuster(key) {
    return loaderError().has(key) ? `?t=${Date.now()}` : '';
}
function isStyleExists(url) {
    const { pathname, search } = new URL(url);
    const path = `${pathname}${search}`;
    const styleElements = document.querySelectorAll(`link[href$='${path}']`);
    return !!styleElements.length;
}
//# sourceMappingURL=loader.js.map